<template>
    <div class="update-profile">
        <titan-form :schema="schema" v-on:saveData="saveData()" :model="dataItem"/>
        <div>PIN: {{pin}}</div>
        <div>App version: {{appVersion}}</div>
    </div>
</template>

<script>
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            TheHeader,
            TitanForm
        },
        mounted() {
            this.initData();
        },
        methods: {
            initData() {
                this.loading = true;
                this.$store.dispatch('account/get').then(res => {
                    this.dataItem = {...res};
                    if(res.hasOwnProperty('skipSecurityInit') && res.skipSecurityInit === true) {
                        this.pin = this.getLoggedUser().getSecurityPin();
                    }
                    else {
                        this.pin = '***';
                    }
                    this.appVersion = this.getAppVersion();
                    this.loading = false;
                }).catch(res => {
                    this.loading = false;
                });
            },
            getAppVersion() {
                let version = 'unknown';
                let scripts = document.getElementsByTagName('script');
                let lastScript = scripts[scripts.length-1];
                if(lastScript) {
                    let scriptName = lastScript.src;
                    if (scriptName.includes('app.') && scriptName.includes('.js')) {
                        version = scriptName.split('app.')[1].replace('.js','');
                    }
                    if(version === 'js') {
                        version = 'dev';
                    }
                }
                return version;
            },
            saveData() {
                this.$store.dispatch('account/updateProfile', this.dataItem).then(res => {
                    this.$store.dispatch('account/get');
                });
            }
        },
        data() {
            return {
                pin: '',
                appVersion: 'unknown',
                loading: true,
                dataItem: {
                    login: '',
                    firstname: '',
                    lastname: '',
                    sex: null,
                    phone: '',
                },
                schema: [
                    {
                        name: this.t('Update profile'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Login'),
                                model: 'login',
                                required: true,
                                validator: VueFormGenerator.validators.email
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title prefix'),
                                model: 'titlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Firstname'),
                                model: 'firstname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Lastname'),
                                model: 'lastname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title sufix'),
                                model: 'titleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                            }, {
                                type: 'titanSelect',
                                label: this.t('Gender'),
                                constant: true,
                                values: [
                                    {
                                        id: 'male',
                                        name: this.t('Male')
                                    }, {
                                        id: 'female',
                                        name: this.t('Female')
                                    }
                                ],
                                model: 'sex'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Phone'),
                                model: 'phone'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Fax'),
                                model: 'fax'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Physician code'),
                                model: 'physicianCode'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Provider code'),
                                model: 'providerCode'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Company name'),
                                model: 'companyName'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Tax registration'),
                                model: 'taxRegistration'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('VAC'),
                                model: 'vac'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Street'),
                                model: 'street'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('City'),
                                model: 'city'
                            }, {
                                type: 'titanSelect',
                                codeBook: 'regions',
                                label: this.t('Region'),
                                model: 'region',
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('ZIP'),
                                model: 'zip'
                            }, {
                                type: 'titanSelect',
                                codeBook: 'country',
                                label: this.t('Country'),
                                model: 'country',
                            }, {
                                type: 'titanSwitch',
                                label: this.t('Marketing purposes consent'),
                                model: 'consentMarketing'
                            },{
                                type: 'titanSwitch',
                                label: this.t('Survey invitations consent'),
                                model: 'consentInvitations'
                            },
                            {
                                type: 'titanImage',
                                label: this.t('Avatar'),
                                model: 'image',
                                originalImageModel: 'imageUrl',
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>
<style lang="scss">
  .update-profile {
    .field-titanSwitch {
      padding:0.35rem 0;
      margin:0;
      margin-bottom: 0.1rem !important;
      border-bottom: 1px solid #dadada;
      .field-wrap {
        float:right;
      }
      label {
        float:left;
        width:80%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/private/profile/components/UpdateProfile.vue